import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

const WooCategoriesGrid = () => {
  const [categories, setCategories] = useState([]);
  const [parentCategory, setParentCategory] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  // Получаем parent из URL параметров
  const parentId = searchParams.get('cat_parent') ? parseInt(searchParams.get('cat_parent')) : 0;

  // Конфигурация API
  const API_CONFIG = {
    baseUrl: 'https://resanta.org/wordpress/wp-json/wc/v3',
    consumerKey: 'ck_ad1ce0bd580ba47f8d8a07183206757f3cc5fbb0',
    consumerSecret: 'cs_9b6b6dcebda9d9897fb362dbc746af065b78203d',
    placeholderImage: 'https://via.placeholder.com/150',
    defaultProductCat: '0'
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        // Загружаем родительскую категорию если есть parentId
        if (parentId !== 0) {
          const parentParams = new URLSearchParams();
          parentParams.append('consumer_key', API_CONFIG.consumerKey);
          parentParams.append('consumer_secret', API_CONFIG.consumerSecret);
          
          const parentResponse = await axios.get(
            `${API_CONFIG.baseUrl}/products/categories/${parentId}?${parentParams.toString()}`
          );
          setParentCategory(parentResponse.data);
        } else {
          setParentCategory(null);
        }

        // Загружаем категории для текущего уровня
        const params = new URLSearchParams();
        params.append('parent', parentId.toString());
        params.append('consumer_key', API_CONFIG.consumerKey);
        params.append('consumer_secret', API_CONFIG.consumerSecret);
        params.append('exclude', API_CONFIG.defaultProductCat);
        params.append('hide_empty', 'true');
        
        const response = await axios.get(
          `${API_CONFIG.baseUrl}/products/categories?${params.toString()}`
        );
        setCategories(response.data);

      } catch (err) {
        setError(err.message || 'Category loading error ');
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [parentId]);

  const handleCategoryClick = async (category) => {
    // Проверяем есть ли подкатегории
    const params = new URLSearchParams();
    params.append('parent', category.id.toString());
    params.append('consumer_key', API_CONFIG.consumerKey);
    params.append('consumer_secret', API_CONFIG.consumerSecret);
    params.append('number', '1');
    
    try {
      const response = await axios.get(
        `${API_CONFIG.baseUrl}/products/categories?${params.toString()}`
      );
      
      if (response.data.length > 0) {
        // Если есть подкатегории - добавляем параметр cat_parent
        searchParams.set('cat_parent', category.id.toString());
        setSearchParams(searchParams);
      } else {
        // Если нет подкатегорий - переходим на страницу категории
        navigate(`/catalog/${category.id}`);
      }
    } catch {
      // В случае ошибки переходим на страницу категории
      navigate(`/catalog/${category.id}`);
    }
  };

  const handleBackClick = () => {
    if (parentCategory?.parent) {
      // Переходим к родительской категории
      searchParams.set('cat_parent', parentCategory.parent.toString());
      setSearchParams(searchParams);
    } else {
      // Возвращаемся к корневым категориям
      searchParams.delete('cat_parent');
      setSearchParams(searchParams);
    }
  };

  if (isLoading) return <div className="loading container">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="woo-categories-container container h-screen my-[30px]">
      {/* Кнопка "Назад" для подкатегорий */}
      {parentId !== 0 && parentCategory && (
        <div className="woo-cat-back">
          <button onClick={handleBackClick} className="woo-back-link">
            ← Back
          </button>
        </div>
      )}

      {/* Сетка категорий */}
      <div className={`woo-categories-grid woo-cat-col-3`}>
        {categories.length > 0 ? (
          categories.map((category) => {
            // Проверяем есть ли подкатегории (асинхронно, поэтому показываем стрелку если count > 0)
            const showArrow = category.count > 0;
            const image = category.image?.src || API_CONFIG.placeholderImage;

            return (
              <div key={category.id} className="woo-cat-item">
                <div
                  onClick={() => handleCategoryClick(category)}
                  className={`woo-cat-link${showArrow ? ' has-children' : ''}`}
                  style={{ cursor: 'pointer' }}
                >
                  <div
                    className="woo-cat-image"
                    style={{
                      backgroundImage: `url(${image})`,
                      backgroundSize: 'contain',
                    }}
                  />
                  <h3 className="woo-cat-title">{category.name}</h3>
                  <div style={{ width: 'fit-content', margin: 'auto' }}>
                    {category.count > 0 && (
                      <span className="woo-cat-count">{category.count} products</span>
                    )}
                    {showArrow && <span className="woo-cat-arrow"></span>}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>Categories not found</p>
        )}
      </div>
    </div>
  );
};

export default WooCategoriesGrid;